import { hasPermission } from '../utils/permissions';

// 權限檢查 Hook
export const usePermission = (user) => {
  const checkPermission = (permission) => {
    return hasPermission(user?.role, permission);
  };

  const checkAnyPermission = (permissions) => {
    return permissions.some(p => hasPermission(user?.role, p));
  };

  const checkAllPermissions = (permissions) => {
    return permissions.every(p => hasPermission(user?.role, p));
  };

  return {
    can: checkPermission,
    canAny: checkAnyPermission,
    canAll: checkAllPermissions,
    isManager: user?.role === 'manager',
    isPurchasing: user?.role === 'purchasing',
    isSales: user?.role === 'sales',
  };
};
